import { Button, Grid } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { AnalyticsEventKeys, DialogNames, QuoteStatuses } from '../constants';
import currentDate from '../currentDate';
import { Dispatch, iRootState } from '../redux/store';
import useOpenFortisForTotalPayment from '../Fortis/useOpenFortisWindowToPayTotal';

const CurrencyPayBadge = function CurrencyPayBadge(): React.ReactElement {
  const orderId = useSelector((state: iRootState) => state.quote.id);
  const hasTerms = useSelector(
    (state: iRootState) => state.paymentTerms.terms.length > 0
  );
  const status = useSelector((state: iRootState) => state.quote.status);

  const showConfirmation = status !== QuoteStatuses.Accepted;
  const dispatch = useDispatch<Dispatch>();
  const { openCurrencyPayWindow } = useOpenFortisForTotalPayment();

  const { push } = useHistory();
  const onClick = function handleOnClick(): void {
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.PayNowClicked
    });

    if (showConfirmation) {
      dispatch.quote.setQuoteStatus(QuoteStatuses.Accepted, currentDate());
      dispatch.dialog.setOpenDialog(DialogNames.SendFeedback);
    } else if (hasTerms) {
      push(`/quote/${orderId}/payment`);
    } else {
      openCurrencyPayWindow();
    }
    dispatch.analytics.sendEvent({
      eventType: AnalyticsEventKeys.AcceptClicked
    });
  };

  return (
    <Grid container spacing={2} alignItems='center'>
      <Grid item>
        <Button variant='contained' onClick={onClick}>
          <FormattedMessage id='payNow' defaultMessage='Pay Now' />
        </Button>
      </Grid>
      <Grid item>
        <img
          src='/poweredbyFortisPay.png'
          alt='Powered By Fortis'
          height={40}
        />
      </Grid>
    </Grid>
  );
};

export default CurrencyPayBadge;
